/* BENUTE / Studio. Mantém o carrinho e os eventos do tema e do provador. */
(() => {
  'use strict';
  if (window.__benutePremiumLoaded) return;
  window.__benutePremiumLoaded = true;
  const initialized = new WeakSet();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMenus(scope) {
    scope.querySelectorAll('.bn-nav-group, [data-bn-filters]:not([data-bn-enhanced])').forEach(details => {
      if (initialized.has(details)) return;
      initialized.add(details);
      const summary = details.querySelector('summary');
      const close = () => { details.open = false; summary.focus({ preventScroll: true }); };
      details.querySelector('[data-bn-close-filters]')?.addEventListener('click', close);
      details.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); close(); } });
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll('.bn-nav-group[open], [data-bn-filters][open]').forEach(other => {
          if (other !== details) other.open = false;
        });
      });
      const count = details.querySelector('[data-bn-filter-count]');
      if (count) {
        const total = details.querySelectorAll('input[type=checkbox]:checked').length;
        count.textContent = total ? `(${total})` : '';
      }
    });
  }

  function initCollection(scope) {
    scope.querySelectorAll('[data-bn-collection]').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      section.querySelectorAll('[data-bn-density]').forEach(button => button.addEventListener('click', () => {
        const grid = section.querySelector('[data-bn-grid]');
        if (grid) grid.dataset.density = button.dataset.bnDensity;
        section.querySelectorAll('[data-bn-density]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      const form = section.querySelector('[data-bn-sort-form]');
      const select = section.querySelector('[data-bn-sort]');
      if (form && select) {
        const sort = e => {
          e.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.assign(url.href);
        };
        form.addEventListener('submit', sort);
        select.addEventListener('change', sort);
      }
    });
  }

  function initProduct(root) {
    if (initialized.has(root)) return;
    const json = root.querySelector('[data-bn-variants]');
    const form = root.querySelector('.bn-product-form');
    if (!json || !form) return;
    let config;
    try { config = JSON.parse(json.textContent); } catch (_) { return; }
    const variants = config.variants || [];
    let selected = config.selectedVariant || variants.find(v => String(v.id) === String(config.selectedId));
    if (!selected) return;
    initialized.add(root);
    const master = form.querySelector('[data-bn-master]');
    const options = form.querySelector('[data-bn-options]');
    const groups = Array.from(form.querySelectorAll('[data-bn-option]'));
    const add = form.querySelector('[data-bn-add]');
    const addLabel = form.querySelector('[data-bn-add-label]');
    const status = form.querySelector('[data-bn-form-status]');
    const gallery = root.querySelector('[data-bn-gallery]');
    let pending = false;
    let navigates = false;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency', currency: root.dataset.bnCurrency || 'BRL'
    });
    const money = cents => formatter.format(Number(cents || 0) / 100);
    const showStatus = (text, error = false, withCart = false) => {
      status.textContent = text;
      status.toggleAttribute('data-error', error);
      if (withCart) {
        status.append(document.createTextNode(' '));
        const link = document.createElement('a');
        link.href = window.routes?.cartUrl || '/cart';
        link.textContent = 'Ver sacola';
        status.append(link);
      }
    };
    const setButton = () => {
      if (!add) return;
      add.disabled = pending || navigates || !selected?.available;
      add.setAttribute('aria-busy', String(pending || navigates));
      addLabel.textContent = pending ? 'Adicionando…' : navigates ? 'Carregando opção…' : !selected ? 'Combinação indisponível' : !selected.available ? 'Esgotado' : config.preorder ? 'Comprar em pré-venda' : 'Adicionar à sacola';
    };
    const syncOptionLabels = () => groups.forEach((group, index) => {
      const checked = group.querySelector('input:checked');
      const label = group.querySelector('[data-bn-option-label]');
      if (label) label.textContent = checked?.value || '';
      group.querySelectorAll('input').forEach(input => {
        // Não bloqueia outras combinações: apenas sinaliza a disponibilidade atual.
        const available = variants.some(v => v.available && v.options.every((value, i) => value === (i === index ? input.value : groups[i]?.querySelector('input:checked')?.value)));
        input.closest('label').classList.toggle('is-unavailable', !config.serverVariants && !available);
      });
    });
    const colorIndex = Number(root.dataset.bnColorIndex ?? -1);
    const normalizeColor = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
    const allCells = gallery ? Array.from(gallery.children) : [];
    let activeColor = null;
    const changeImage = variant => {
      const color = normalizeColor(variant?.options?.[colorIndex] || groups[colorIndex]?.querySelector('input:checked')?.value);
      if (color === activeColor) return;
      activeColor = color;
      const tokens = cell => (cell.dataset.bnMediaColor || '').split('|').map(normalizeColor).filter(Boolean);
      const matches = color && allCells.filter(cell => tokens(cell).includes(color));
      const hasTags = allCells.some(cell => tokens(cell).length);
      // No assignment means the original full gallery remains available.
      // With tags, never substitute another color's photos for the selected one.
      let visible = !hasTags || colorIndex < 0 ? allCells : matches?.length ? allCells.filter(cell => tokens(cell).includes(color) || tokens(cell).includes('todas')) : allCells.filter(cell => !tokens(cell).length || tokens(cell).includes('todas'));
      const primaryMediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      if (!visible.length && primaryMediaId) visible = allCells.filter(cell => String(cell.dataset.bnMediaId) === String(primaryMediaId));
      allCells.forEach(cell => {
        cell.hidden = !visible.includes(cell);
        if (cell.hidden) cell.querySelectorAll('video').forEach(video => video.pause());
      });
      let notice = root.querySelector('[data-bn-gallery-notice]');
      if (!notice) { notice = document.createElement('p'); notice.dataset.bnGalleryNotice = ''; notice.className = 'bn-gallery-notice'; gallery?.after(notice); }
      notice.textContent = visible.length ? '' : 'As fotos desta cor ainda não estão disponíveis.';
      notice.hidden = Boolean(visible.length);
      if (gallery) { gallery.dataset.count = String(visible.length); gallery.scrollTo({ left: 0, behavior: 'auto' }); gallery.dispatchEvent(new Event('bn:gallery')); }
    };
    const apply = (variant, updateURL = true, updateImage = true) => {
      const previousVariant = selected;
      selected = variant;
      master.disabled = !variant;
      if (variant) {
        if (!Array.from(master.options).some(o => o.value === String(variant.id))) {
          master.add(new Option(variant.title, String(variant.id)));
        }
        master.value = String(variant.id);
        root.querySelector('[data-bn-price]').textContent = money(variant.price);
        const compare = root.querySelector('[data-bn-compare]');
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = money(variant.compare_at_price);
        if (updateImage) changeImage(variant);
      }
      if (!variant) {
        root.querySelector('[data-bn-price]').textContent = '—';
        root.querySelector('[data-bn-compare]').hidden = true;
        if (updateImage) changeImage(null);
      }
      root.querySelector('[data-bn-stock]').textContent = !variant ? 'Esta combinação não está disponível.' : variant.available ? 'Disponível' : 'Esgotado nesta opção';
      setButton();
      syncOptionLabels();
      if (updateURL && variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        url.searchParams.delete('option_values');
        window.history.replaceState(window.history.state, '', url.href);
      }
      root.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant, previousVariant } }));
      if (!variant) form.querySelectorAll('[data-benute-action]').forEach(button => { button.disabled = true; });
    };

    groups.forEach((group, index) => {
      group.querySelectorAll('input').forEach(input => { input.checked = input.value === selected.options[index]; });
    });
    if (options) options.hidden = false;
    root.dataset.bnReady = '';
    apply(selected, false, true);
    // A Shopify limita o JSON de variantes. Produtos grandes usam a seleção no servidor.
    options?.addEventListener('change', () => {
      showStatus('');
      const inputs = groups.map(g => g.querySelector('input:checked'));
      if (config.serverVariants && inputs.every(i => i?.dataset.bnOptionValueId)) {
        navigates = true;
        setButton();
        form.querySelectorAll('[data-benute-action]').forEach(button => { button.disabled = true; });
        const url = new URL(root.dataset.bnProductUrl, window.location.origin);
        url.searchParams.set('option_values', inputs.map(i => i.dataset.bnOptionValueId).join(','));
        window.location.assign(url.href);
        return;
      }
      apply(variants.find(v => v.options.every((value, index) => value === inputs[index]?.value)) || null);
    });
    master.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === master.value);
      if (!variant) return;
      groups.forEach((group, index) => group.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; }));
      apply(variant);
    });
    form.addEventListener('submit', async e => {
      if (!add) { e.preventDefault(); return; }
      if (pending || navigates || !selected?.available) { e.preventDefault(); return; }
      if (!form.reportValidity()) { e.preventDefault(); return; }
      // A opção "página do carrinho" conserva o POST nativo da Shopify.
      if (!window.BenuteCart && window.theme?.cartType !== 'drawer') return;
      e.preventDefault();
      const addedVariant = selected;
      const quantity = Number(form.querySelector('[name="quantity"]').value);
      if (!Number.isInteger(quantity) || quantity < 1) { showStatus('Informe uma quantidade válida.', true); return; }
      pending = true;
      setButton();
      showStatus('');
      const data = new FormData(form);
      Array.from(data.keys()).filter(key => key.startsWith('bn-option-')).forEach(key => data.delete(key));
      let confirmed = false;
      try {
        const endpoint = new URL(window.routes?.cartAddUrl || '/cart/add', window.location.origin);
        if (!endpoint.pathname.endsWith('.js')) endpoint.pathname += '.js';
        if (window.BenuteCart) {
          await window.BenuteCart.add(data, add);
          confirmed = true;
          showStatus('Peça adicionada à sacola.', false, true);
          return;
        }
        const response = await fetch(endpoint.href, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) {
          const message = typeof result.description === 'string' ? result.description : 'Não foi possível adicionar esta quantidade. Confira a disponibilidade.';
          showStatus(message, true);
          return;
        }
        confirmed = true;
        showStatus('Peça adicionada à sacola.', false, true);
        root.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: addedVariant, quantity } }));
      } catch (error) {
        if (window.BenuteCart) { showStatus(error.message || 'Confira sua sacola antes de tentar novamente.', true, true); return; }
        showStatus(confirmed ? 'Peça adicionada. Abra a sacola para continuar.' : 'Não foi possível confirmar. Confira a sacola antes de tentar novamente.', !confirmed, true);
      } finally {
        pending = false;
        setButton();
      }
    });

    if (gallery) {
      const cells = () => Array.from(gallery.children).filter(cell => !cell.hidden);
      const step = () => cells().length > 1 ? cells()[1].offsetLeft - cells()[0].offsetLeft : gallery.clientWidth;
      const current = () => Math.max(0, Math.min(cells().length - 1, Math.round(gallery.scrollLeft / (step() || 1))));
      const renderCounter = () => {
        const counter = root.querySelector('[data-bn-gallery-counter]');
        if (counter) counter.textContent = `${cells().length ? current() + 1 : 0} / ${cells().length}`;
        const prev = root.querySelector('[data-bn-gallery-prev]');
        const next = root.querySelector('[data-bn-gallery-next]');
        if (prev) prev.disabled = current() === 0;
        if (next) next.disabled = current() === cells().length - 1;
      };
      const move = delta => gallery.scrollTo({ left: Math.max(0, Math.min(cells().length - 1, current() + delta)) * step(), behavior: reducedMotion() ? 'auto' : 'smooth' });
      root.querySelector('[data-bn-gallery-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-bn-gallery-next]')?.addEventListener('click', () => move(1));
      gallery.addEventListener('scroll', renderCounter, { passive: true });
      gallery.addEventListener('bn:gallery', renderCounter);
      renderCounter();
    }
    const dialog = root.querySelector('[data-bn-photo-dialog]');
    let opener, zoomIndex = 0;
    const zoomButtons = () => Array.from(root.querySelectorAll('[data-bn-zoom]')).filter(b => !b.closest('.bn-gallery__cell').hidden);
    const renderZoom = () => {
      const buttons = zoomButtons();
      zoomIndex = Math.max(0, Math.min(buttons.length - 1, zoomIndex));
      const button = buttons[zoomIndex]; if (!button) return;
      const image = dialog.querySelector('[data-bn-photo-image]');
      image.src = button.dataset.bnZoom; image.alt = button.querySelector('img')?.alt || '';
      dialog.querySelector('[data-bn-photo-prev]').disabled = zoomIndex === 0;
      dialog.querySelector('[data-bn-photo-next]').disabled = zoomIndex >= buttons.length - 1;
    };
    if (dialog?.showModal) {
      root.querySelectorAll('[data-bn-zoom]').forEach(button => button.addEventListener('click', () => {
        opener = button; zoomIndex = zoomButtons().indexOf(button); renderZoom(); dialog.showModal(); document.documentElement.classList.add('bn-modal-open');
      }));
      dialog.querySelector('[data-bn-photo-prev]').addEventListener('click', () => { zoomIndex--; renderZoom(); });
      dialog.querySelector('[data-bn-photo-next]').addEventListener('click', () => { zoomIndex++; renderZoom(); });
      dialog.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); zoomIndex += e.key === 'ArrowRight' ? 1 : -1; renderZoom(); } });
      dialog.querySelector('[data-bn-close-photo]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('bn-modal-open'); opener?.focus({ preventScroll: true }); });
    }
    const sticky = root.querySelector('[data-bn-sticky]');
    const updateSticky = () => {
      if (!sticky) return;
      sticky.querySelector('[data-bn-sticky-price]').textContent = selected ? money(selected.price) : '';
      sticky.querySelector('[data-bn-sticky-selection]').textContent = selected?.title === 'Default Title' ? '' : selected?.title || 'Escolha uma opção disponível';
      const button = sticky.querySelector('[data-bn-sticky-add]');
      if(button) { button.disabled = pending || !selected?.available; button.textContent = selected?.available ? 'Adicionar à sacola' : 'Indisponível'; }
    };
    root.addEventListener('variant:changed', updateSticky); updateSticky();
    sticky?.querySelector('[data-bn-sticky-add]')?.addEventListener('click', () => { if (form.reportValidity()) form.requestSubmit(add); });
    if (sticky && add && root.dataset.bnStickyEnabled === 'true' && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if(!root.isConnected) { observer.disconnect(); return; } const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0; }, { threshold: 0 }); observer.observe(add);
    }
    if ('ResizeObserver' in window) {
      const panel = root.querySelector('.bn-buy-panel');
      const observer = new ResizeObserver(() => {
        if (!root.isConnected) { observer.disconnect(); return; }
        const headerHeight = document.querySelector('#shopify-section-header')?.getBoundingClientRect().height || 135;
        panel.classList.toggle('is-tall', panel.scrollHeight > window.innerHeight - headerHeight - 40);
      });
      observer.observe(panel);
    }
  }

  function initialize(scope) {
    initMenus(scope);
    initCollection(scope);
    scope.querySelectorAll('[data-bn-product]').forEach(initProduct);
  }
  document.addEventListener('click', e => {
    document.querySelectorAll('.bn-nav-group[open], [data-bn-filters][open]').forEach(details => {
      if (!details.contains(e.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();
